import React, { useEffect, useState } from "react";
import {
    Area,
    CartesianGrid,
    ComposedChart,
    ResponsiveContainer,
    Tooltip as ChartTooltip,
    XAxis,
    YAxis,
} from "recharts";
import moment from "moment";
import {Card, Spin} from "antd";
import Api from "../../api";
import { LoadingOutlined } from "@ant-design/icons";
import DashboardChartTitle from "./dashboard-chart-title";
import {
    DASHBOARD_AXIS_TICK,
    DASHBOARD_Y_AXIS_WIDTH,
    formatDashboardXAxis,
    formatDashboardYAxisCurrency,
    getDashboardDefaultDateRange,
} from "./dashboard-chart-utils";

const DailyPayments = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const loadData = (startDate, endDate) => {
        const query = startDate && endDate ? `?start_date=${startDate}&end_date=${endDate}` : '';
        setLoading(true);

        Api.get('/admin/daily-payments' + query).then(res => {
            setData(res.data);
            setLoading(false);
        });
    };

    useEffect(() => {
        const {startDate, endDate} = getDashboardDefaultDateRange();
        loadData(startDate, endDate);
    }, []);

    const formatTooltip = (value) => `${value} EUR`;

    const handleRangeChange = (dates, dateStrings) => {
        if (dates) {
            loadData(dateStrings[0], dateStrings[1]);
        } else {
            const {startDate, endDate} = getDashboardDefaultDateRange();
            loadData(startDate, endDate);
        }
    };

    // Calculate totals safely
    const totalRevenue = data.reduce((sum, item) => sum + (Number(item.total_payment) || 0), 0);
    const maxPayment = Math.max(...data.map(item => item.total_payment), 0);

    return (
        <Card
            className="dashboard-chart-card"
            title={
                <DashboardChartTitle
                    title="Revenue"
                    value={`${totalRevenue.toFixed(2)}€`}
                    tagColor="green"
                    chartColor="limegreen"
                    onRangeChange={handleRangeChange}
                />
            }
            bordered={false}
        >
            {loading ? (
                <Spin indicator={<LoadingOutlined style={{ fontSize: 30 }} spin />} className="spinner-loader" />
            ) : (
                <div className="dashboard-chart">
                    <ResponsiveContainer width="100%" height={165}>
                    <ComposedChart
                        data={data}
                        syncId="paymentChart"
                        margin={{ top: 8, right: 8, left: 0, bottom: 0 }}
                    >
                        <defs>
                            <linearGradient id="colorUv2" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="5%" stopColor="limegreen" stopOpacity={0.3} />
                                <stop offset="95%" stopColor="limegreen" stopOpacity={0} />
                            </linearGradient>
                        </defs>

                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                            tickFormatter={formatDashboardXAxis}
                            tick={DASHBOARD_AXIS_TICK}
                            minTickGap={4}
                            interval="preserveStartEnd"
                            type="category"
                            dataKey="date"
                        />
                        <YAxis
                            tickFormatter={formatDashboardYAxisCurrency}
                            tick={DASHBOARD_AXIS_TICK}
                            width={DASHBOARD_Y_AXIS_WIDTH}
                            type="number"
                            domain={[0, maxPayment + 100]}
                        />
                        <ChartTooltip labelFormatter={value => moment(new Date(value)).format('DD.MM.YYYY')} formatter={formatTooltip} />
                        <Area
                            type="monotone"
                            name="Maksed"
                            dataKey="total_payment"
                            stroke="limegreen"
                            fill="url(#colorUv2)"
                        />
                    </ComposedChart>
                </ResponsiveContainer>
                </div>
            )}
        </Card>
    );
};

export default DailyPayments;
